///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { SystemInfoDTO } from '../../../generated/shared-types.model';

export const systemInfoFeatureKey = 'systemInfo';

export interface SystemInfoState {
    isLoading: boolean;
    info: SystemInfoDTO;
}

export const initialState: SystemInfoState = {
    isLoading: false,
    info: {
        version: '',
        copyright: '',
        supportEmail: '',
        registrationUrl: '',
        activeProfiles: [],
        projectInterchange: {
            exportEnabled: false,
            importEnabled: false
        },
        emailVerificationTokenLength: 8
    }
};
